export const IS_USER_BIRTHDAY_CMS_KEY = 'birthday';
export const IS_USER_MOSAIC_CMS_KEY = 'loggedIn';
